module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_e-Akte_ro.ee5bae0a.svg";